import React from "react";
import Header from "../../Componets/Header";
import Menus from "../../Componets/Menus";
import ProductIcon from "../../Assets/Svg/products";
import InventoryIcon from "../../Assets/Svg/inventory";
import BillingIcon from "../../Assets/Svg/billing";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import ExpenseIcon from "../../Assets/Svg/expense";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import DonwloaduploadIcon from "../../Assets/Svg/donwloadupload";
import { useNavigate } from "react-router-dom";
import UploadIcon from "../../Assets/Svg/upload";
import ArrowrightIcon from "../../Assets/Svg/arrowright";

const Importexport = () => {
  const navigate = useNavigate();

  let header = {
    name: "Import/Export",
    components: [
    ],
    navigate: {
    tabs: [
      {
        name: "Import/Export",
        path: "",
      },
     
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
  };

  const formdata = async (data) => {
    console.log(data);
  };

  const menu = [
    {
      icon: <ProductIcon width={22} height={22} />,
      name: "Products",
      options: [
        {
          icon: <DonwloaduploadIcon />,
          name: "Products",
          description: "Import/Export",
          url: "/app/importexport/products",
        },
        {
          icon: <UploadIcon width={16} />,
          name: "Branch Products",
          description: "Bulk upload",
          url: "/app/importexport/branchproducts",
        },
      ],
    },
    {
      icon: <InventoryIcon width={22} height={22} />,
      name: "Inventory",
      options: [
        {
          icon: <DonwloaduploadIcon />,
          name: "Inventory",
          description: "Import/Export",
          url: "/app/importexport/inventory",
        },
      ],
    },
  ];

  const handleClick = (url) => {
    if (url) {
      navigate(url);
    }
  };

  return (
    <Header headers={header} formdata={formdata}>
      <div>
        {menu?.map((value, index) => {
          return (
            <div
              className={
                index > 0
                  ? "mt-6 my-2 bg-white rounded-md p-4"
                  : "bg-white my-2 bg-white rounded-md p-4"
              }
            >
              <div className="flex">
                <div>{value?.icon}</div>
                <div className="text-medium pl-2">{value?.name}</div>
              </div>
              <div className="mt-4 grid grid-cols-4 gap-4">
                {value?.options?.map((v, i) => {
                  return (
                    <div
                      className="flex bg-white p-1 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                      onClick={() => handleClick(v?.url)}
                    >
                      <div className="p-3 rounded-lg bg-gray-300">
                        <div className="my-auto">{v?.icon}</div>
                      </div>
                      <div className="text-left px-2 my-auto">
                        <div className="text-sm">{v?.name}</div>
                        <div className="text-xs text-gray-400">
                          {v?.description}
                        </div>
                      </div>
                      <div className="float-right ml-auto my-auto text-gray-400 pr-3">
                        <ArrowrightIcon />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Header>
  );
};

export default Importexport;
